/**
 * @generated SignedSource<<73323f329e6a3899ae74d875df0be24e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WATaskSingleSettingsScreenQuery$variables = {
  taskId: string;
};
export type WATaskSingleSettingsScreenQuery$data = {
  readonly task: {
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskSingleSettingsScreenComponent_task">;
  } | null;
};
export type WATaskSingleSettingsScreenQuery = {
  response: WATaskSingleSettingsScreenQuery$data;
  variables: WATaskSingleSettingsScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "taskId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WATaskSingleSettingsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WidgetTaskSingleSettingsScreenComponent_task"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WATaskSingleSettingsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isTask"
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Routine",
            "kind": "LinkedField",
            "name": "routine",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "ownerTeam",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineSectionVersion",
            "kind": "LinkedField",
            "name": "activeSectionVersions",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineSection",
                "kind": "LinkedField",
                "name": "section",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "assignedTeam",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unit",
                "storageKey": null
              }
            ],
            "type": "TaskNumber",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentiments",
                "storageKey": null
              }
            ],
            "type": "TaskCheck",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e3f2f585fdf05ee7719373d9a22357fc",
    "id": null,
    "metadata": {},
    "name": "WATaskSingleSettingsScreenQuery",
    "operationKind": "query",
    "text": "query WATaskSingleSettingsScreenQuery(\n  $taskId: ID!\n) {\n  task(id: $taskId) {\n    __typename\n    ...WidgetTaskSingleSettingsScreenComponent_task\n    id\n  }\n}\n\nfragment ListSectionHeaderRoutine_Routine on Routine {\n  title\n  ownerTeam {\n    ...TeamIconCircleComponent_Team\n    id\n  }\n}\n\nfragment RoutineSectionListItem_RoutineSectionVersion on RoutineSectionVersion {\n  title\n  section {\n    assignedTeam {\n      ...TeamIconCircleComponent_Team\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment TaskListItemIcon_Task on Task {\n  __isTask: __typename\n  __typename\n  ... on TaskNumber {\n    unit\n  }\n  ... on TaskCheck {\n    sentiments\n  }\n  ... on TaskText {\n    __typename\n  }\n}\n\nfragment TaskListItemTitle_Task on Task {\n  __isTask: __typename\n  title\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n\nfragment WidgetTaskSingleSettingsScreenComponentTask_task on Task {\n  __isTask: __typename\n  ...TaskListItemIcon_Task\n  ...TaskListItemTitle_Task\n  routine {\n    ...ListSectionHeaderRoutine_Routine\n    id\n  }\n}\n\nfragment WidgetTaskSingleSettingsScreenComponent_task on Task {\n  __isTask: __typename\n  id\n  routine {\n    type\n    id\n  }\n  ...WidgetTaskSingleSettingsScreenComponentTask_task\n  activeSectionVersions {\n    id\n    section {\n      id\n    }\n    ...RoutineSectionListItem_RoutineSectionVersion\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a4dc8d6d4825c595b7f2dbfe9eb9696";

export default node;
